import React from "react";
import classnames from 'classnames';
import { Icon } from "rhombus-react";
import { BasicAction } from "widgets/ActionMenu";
import Permissioned from "widgets/Permissioned";
import { AD_STUDIO_URL, CV, CREATIVE_VIEW } from "utils/constants";

export default function AdStudioLink({ creativeId, iconOnly, isDisabled }){
	let url = `${AD_STUDIO_URL}/app/studio/${creativeId}/builder/0/shome/`;
	const className = classnames('action-link', { 'is-disabled': isDisabled });

	if(iconOnly){
		return (
			<Permissioned domain={CV} action={CREATIVE_VIEW.UPLOAD_AD_FILES}>
				<a
					className = {className}
					data-tip = "Open in Ad Studio"
					href = {url}
					target = "_blank"
				>
					<span className="action-icon">
						<Icon
							className = "bounce-circle"
							// When it's iconOnly, we use far
							name = "far fa-palette"
						/>
					</span>
				</a>
			</Permissioned>
		);
	} else {
		return (
			<BasicAction
				// When it's in a submenu, we use fas
				iconName = "fas fa-palette"
				name = "Open in Ad Studio"
				handleClick = {() => {
					window.open(url, "_blank");
				}}
				isDisabled={isDisabled}
			/>
		);
	}
}

AdStudioLink.diplayName = "AdStudioLink";
AdStudioLink.defaultProps = {
	creativeId:-1,
	iconOnly:true,
};
